import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Input, Textarea, Btn } from './Input';
import { useToast } from './Toast';

export default function KlientForm({ initial, onSave, onClose }) {
  const { t } = useTranslation();
  const toast = useToast();
  const [form, setForm] = useState(initial ? {
    imie_nazwisko: initial.imie_nazwisko || (!initial.nazwa_firmy ? initial.nazwa || '' : ''),
    nazwa_firmy:   initial.nazwa_firmy   || '',
    telefon:       initial.telefon       || '',
    email:         initial.email         || '',
    notatki:       initial.notatki       || '',
    adres:         initial.adres         || '',
    nip:           initial.nip           || '',
    lang:          initial.lang === 'en' ? 'en' : 'pl',
  } : {
    imie_nazwisko: '',
    nazwa_firmy:   '',
    telefon:       '',
    email:         '',
    notatki:       '',
    adres:         '',
    nip:           '',
    lang:          'pl',
  });
  const [loading, setLoading] = useState(false);
  const [nameError, setNameError] = useState('');

  const set = (k, v) => {
    setForm(f => ({ ...f, [k]: v }));
    if ((k === 'imie_nazwisko' || k === 'nazwa_firmy') && nameError) setNameError('');
  };

  const submit = async e => {
    e.preventDefault();
    if (!form.imie_nazwisko && !form.nazwa_firmy) {
      setNameError(t('clients.nameOrCompanyRequired'));
      return;
    }
    setLoading(true);
    try {
      await onSave(form);
      onClose();
    } catch (err) {
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={submit} className="flex flex-col gap-5">
      <div className="flex flex-col gap-3">
        <p className="section-label">{t('clients.contactPerson')}</p>
        <Input label={t('clients.fullName')} placeholder="np. Jan Kowalski"
          value={form.imie_nazwisko || ''} onChange={e => set('imie_nazwisko', e.target.value)}
          error={nameError} />
        <div className="grid sm:grid-cols-2 gap-3">
          <Input label={t('clients.phone')} type="tel" placeholder="+48 600 000 000"
            value={form.telefon || ''} onChange={e => set('telefon', e.target.value)} />
          <Input label={t('clients.email')} type="email" placeholder="jan@firma.pl"
            value={form.email || ''} onChange={e => set('email', e.target.value)} />
        </div>
        <Textarea label={t('clients.notes')} placeholder="Opcjonalne uwagi..."
          value={form.notatki || ''} onChange={e => set('notatki', e.target.value)} />
        <div className="flex flex-col gap-1">
          <label style={{ fontSize: '9px', fontWeight: 600, letterSpacing: '0.07em', textTransform: 'uppercase', color: 'var(--ink3)' }}>
            {t('clients.portalLanguage')}
          </label>
          <div className="flex gap-1">
            {[{ v: 'pl', l: t('clients.langPl') }, { v: 'en', l: t('clients.langEn') }].map(o => {
              const active = form.lang === o.v;
              return (
                <button key={o.v} type="button" onClick={() => set('lang', o.v)}
                  className="px-3 py-2 rounded-btn transition-colors flex-1"
                  style={active
                    ? { background: 'rgba(184,84,40,0.10)', color: 'var(--ink)', border: '1px solid var(--acc)', fontSize: '11px', fontWeight: 700 }
                    : { background: 'var(--bg4)', color: 'var(--ink3)', border: '1px solid var(--border)', fontSize: '11px', fontWeight: 600 }}>
                  {o.l}
                </button>
              );
            })}
          </div>
        </div>
      </div>

      <div className="flex flex-col gap-3">
        <p className="section-label">{t('clients.invoiceData')}</p>
        <Input label={t('clients.companyName')} placeholder="np. Kowalski Nieruchomości Sp. z o.o."
          value={form.nazwa_firmy || ''} onChange={e => set('nazwa_firmy', e.target.value)} />
        <Input label={t('clients.address')} placeholder="ul. Przykładowa 1, 00-001 Warszawa"
          value={form.adres || ''} onChange={e => set('adres', e.target.value)} />
        <Input label={t('clients.nip')} placeholder="000-000-00-00"
          value={form.nip || ''} onChange={e => set('nip', e.target.value)} />
      </div>

      <div className="flex justify-end gap-2 pt-1">
        <Btn type="button" variant="ghost" onClick={onClose}>{t('common.cancel')}</Btn>
        <Btn type="submit" disabled={loading}>{loading ? t('common.saving') : t('common.save')}</Btn>
      </div>
    </form>
  );
}
